import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
  from,
} from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';

import config from './config';

const uploadLink = createUploadLink({
  uri: `${config.apiUrl}/graphql`,
  credentials: 'include',
});

const httpLink = createHttpLink({
  uri: `${config.apiUrl}/graphql`,
  credentials: 'include',
});

export const client = new ApolloClient({
  link: from([uploadLink as unknown as ApolloLink, httpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  name: 'CotatiOne',
  version: '2.0',
});
